var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelMessengerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger",
    transform: "translate(-352 -378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 22,
    height: 22,
    transform: "translate(352 378)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2875",
    "data-name": "Group 2875",
    transform: "translate(-16 154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M14,24.305A10.83,10.83,0,0,0,25,13.653,10.831,10.831,0,0,0,14,3,10.831,10.831,0,0,0,3,13.653a10.489,10.489,0,0,0,3.763,8.023v2.156A1.159,1.159,0,0,0,8.387,24.9l2.392-1.059A11.33,11.33,0,0,0,14,24.305Z",
    transform: "translate(365 221)",
    fill: "#0098ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M12.692,12.662,9.111,16.4c-.384.4.306.883.832.581L13,15.225a1.128,1.128,0,0,1,1.062-.006l2.719,1.515a1.448,1.448,0,0,0,1.646-.185l3.755-3.872c.389-.4-.306-.887-.833-.581l-3.232,1.879a1.127,1.127,0,0,1-1.066.008l-2.71-1.51A1.447,1.447,0,0,0,12.692,12.662Z",
    transform: "translate(363.352 220.016)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelMessengerIcon);
export default __webpack_public_path__ + "static/media/channel-messenger-icon.d696d7e51aab5d4c616e786be662d991.svg";
export { ForwardRef as ReactComponent };